// ru
function ruPlural(choice, choicesLength) {
  const n = Math.abs(choice);
  if (choicesLength === 1) return 0;
  if (n % 10 === 1 && n % 100 !== 11) return 0;
  if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) return 1;
  return 2;
}

// en
function enPlural(choice) {
  return choice === 1 ? 0 : 1;
}

// es
function esPlural(choice) {
  return choice === 1 ? 0 : 1;
}

// it
function itPlural(choice) {
  return choice === 1 ? 0 : 1;
}

// fr
function frPlural(choice) {
  return (choice === 0 || choice === 1) ? 0 : 1;
}

// de
function dePlural(choice) {
  return choice === 1 ? 0 : 1;
}

// pt
function ptPlural(choice) {
  return choice === 1 ? 0 : 1;
}

// ko
function koPlural() {
  return 0;
}

// ar — 6 form: zero, one, two, few, many, other
function arPlural(choice) {
  const n = Math.abs(choice);
  if (n === 0) return 0; // zero
  if (n === 1) return 1; // one
  if (n === 2) return 2; // two
  if ((n % 100) >= 3 && (n % 100) <= 10) return 3; // few
  if ((n % 100) >= 11 && (n % 100) <= 99) return 4; // many
  return 5; // other
}

export default {
  ru: ruPlural,
  en: enPlural,
  es: esPlural,
  it: itPlural,
  fr: frPlural,
  de: dePlural,
  pt: ptPlural,
  ko: koPlural,
  ar: arPlural,
};
